import React from 'react'
import {HiArrowNarrowRight} from 'react-icons/hi'
import { Link } from 'react-scroll'

const Home = () => {
  return (
    <div name='home' className='bg-[#0a192f] w-full h-screen'>
        {/*CONTAINER */}
        <div className='max-w-[1000px] mx-auto px-8 flex flex-col justify-center h-full '>
                <p className='text-pink-600'>Hi,my name is</p>
                <h1 className='text-4xl text-slate-50  sm:text-7xl font-bold'>Nana Kweku Otoo</h1>
                <h2 className='text-4xl text-[#8892b0] sm-text-7xl font-bold '>I am a Front-end Engineer</h2>
                <p className='text-[#8892b0] py-4 max-w-[700px] '>I am a Front-end Engineer specializing in building (and occasionally
                    designing) exceptional digital experiences. Currently, I'm focused on
                    building responsive frontend web applications.</p>
                 <div>
                    <Link to='work'  smooth={true} duration={600}>
                      <button className='text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600'>
                          View Work <span className=' group-hover:rotate-90 duration-500 ml-3 '><HiArrowNarrowRight/></span>
                      </button>
                    </Link>
                 </div>   
        </div>
    </div>
  ) 
}

export default Home

